import React from "react";
import { defaultDropList } from "../Data/WBComponentDefaults";
import { AttributeDefinition, AttributeInputType } from "../Data/WBData";
import { ButtonIcon } from "../Icons/ComponentIcons";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import {  WBComponent } from "./WBComponent";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { SiteData } from "../Data/SiteData";
import { AttributeCollection, getNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { UpdateStyleFunction } from "../Stylebuilder";

import RenderDormantBookButton from "vagaro-website-rendering/src/components/ComponentRenders/RenderDormantBookButton";
import ApplyToGlobalButton from "../Menus/ApplyToGlobalButton";
import BusinessPlaceHolder from "./BusinessDataRendering/BusinessPlaceHolder";
import { GetNodeComponenentAttributeBinding, GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";





export default class DormantBookButton extends WBComponent {




    constructor(){
        super();

        this.typename = wBComponentTypeNames.dormantButton;
        this.displayName = "External Booking";
        this.dropList = defaultDropList;
        this.editList = ["buttonType","width","height"];
        this.primaryEditAttributes = ["buttonType"];
        this.hideAdvancedSettings = true;
        this.icon =<> <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" height={"1em"} viewBox="0 0 512 512"><path d="M432 320H400a16 16 0 0 0 -16 16V448H64V128H208a16 16 0 0 0 16-16V80a16 16 0 0 0 -16-16H48A48 48 0 0 0 0 112V464a48 48 0 0 0 48 48H400a48 48 0 0 0 48-48V336A16 16 0 0 0 432 320zM488 0h-128c-21.4 0-32.1 25.9-17 41l35.7 35.7L135 320.4a24 24 0 0 0 0 34L157.7 377a24 24 0 0 0 34 0L435.3 133.3 471 169c15 15 41 4.5 41-17V24A24 24 0 0 0 488 0z"/></svg></>

    }

    RenderMenu({ editList, primaryList, layoutNode, screenSize, updateFunc, saveFunc, showScreenSize, siteData }: { updateFunc: UpdateStyleFunction; saveFunc: Function; editList: string[]; primaryList: string[]; layoutNode: AttributeCollection | null; screenSize: ScreenSize; showScreenSize?: boolean | undefined; siteData: SiteData;  }): JSX.Element {
        const content =  super.RenderMenu({editList,primaryList,layoutNode,screenSize,updateFunc,saveFunc,showScreenSize,siteData});

        if(!layoutNode)
            return content;




        const getCollection = ()=>{
            let collection = siteData.siteStyling.buttonPrimary;
            const newBtnType = getNodeComponentAttributeValue(layoutNode,"buttonType","primary");
            switch(newBtnType){
                case "primary":

                    collection = siteData.siteStyling.buttonPrimary;
                    break;
                case "secondary":
                    collection = siteData.siteStyling.buttonSecondary;
                    break;
                case "tertiary":
                    collection = siteData.siteStyling.buttonTertiary;
                    break;
                default:
                    break;
            }
            return collection;
        }

        return(
            <>
            {content}

            <br></br>
            {screenSize===ScreenSize.Desktop&&


            <ApplyToGlobalButton siteData={siteData} layoutNode={layoutNode} getCollectionFunc={getCollection} />}
            </>
        )

    }

    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {
        return [

            new AttributeDefinition("buttonType","Button Type","",AttributeInputType.SelectField,
            [{label:"Primary",value:"primary"},{label:"Secondary",value:"secondary"},{label:"Tertiary",value:"tertiary"}]),

            new AttributeDefinition("link","Button Link","",AttributeInputType.LinkField),
            new AttributeDefinition("linkOpenType","Link Behavior","",AttributeInputType.Ignore,
            [{label:"Same Window",value:""},{label:"New Tab",value:"_blank"}]),
        ];
    }


    RenderLayout({screenSize,component,children,userContext,isEditor}:WBRenderProps)
     {


    return  <div {...GetNodeDomAttributes("" ,component,screenSize,isEditor)}  {...GetNodeComponenentAttributeBinding(component,isEditor)}><RenderDormantBookButton website="" component={component}/></div>

    }

}